import axios from "axios";

// Route the live RankTrust site to the production backend. Preview/dev
// deployments can still override this with REACT_APP_BACKEND_URL.
function resolveBackendUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL?.replace(/\/+$/, "");

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const isRankTrustDomain = host === "ranktrust.io" || host === "www.ranktrust.io";
    if (isRankTrustDomain) {
      return "https://ranktrust.onrender.com";
    }
  }

  return configured || (typeof window !== "undefined" ? window.location.origin : "");
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Authorization fallback from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function formatErr(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(d);
}
